// extracted by mini-css-extract-plugin
export default {"list__checkbox":"ChangeTypeDialog_list__checkbox__rxAa4","list__item":"ChangeTypeDialog_list__item__0KWqn"};